import React from 'react';
import { Button } from 'app/shared/components';
import { usePostAnswer } from 'app/modules/survey';
import { userAgent } from 'config/system';

export interface PostAnswerProps {
  className?: string;
  label: string;
}

function PostAnswer({ className, label }: PostAnswerProps) {
  const [onSubmit, disabled, posting, showButton] = usePostAnswer();

  const onTouchEnd = () => {
    onSubmit();
  };

  const onClick = () => {
    onSubmit();
  };

  if (showButton) {
    return (
      <Button
        className={className}
        color="primary"
        disabled={disabled}
        loading={posting}
        {...{
          ...(userAgent.isIOS && { onTouchEnd }),
          ...(!userAgent.isIOS && { onClick })
        }}
      >
        {label}
      </Button>
    );
  } else {
    return null;
  }
}

export default PostAnswer;
